import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información de contacto", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-inst-email"
}, "Correo institucional", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-pers-email"
}, "Correo personal", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-primary-phone"
}, "Teléfono principal", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-secondary-phone"
}, "Teléfono secundario", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Políticas de tratamiento de datos", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "institución educativa", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "recolectar, almacenar, usar, circular, actualizar y suprimir", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Ley 1581 de 2012", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Decreto 1377 de 2013", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Finalidades (institución educativa):", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Datos de niños, niñas y adolescentes:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Derechos del titular:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Encargados del tratamiento y seguridad:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "Vigencia:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("b", null, "Costos:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-inst-email",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.InstitucionalEmail,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('InstitucionalEmail', val)),
                    placeholder: "Ingrese correo institucional",
                    type: "email"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-pers-email",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.PersonalEmail,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('PersonalEmail', val)),
                    placeholder: "Ingrese correo personal",
                    type: "email"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-primary-phone",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.PrimaryPhone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('PrimaryPhone', val)),
                    placeholder: "Ingrese teléfono principal",
                    type: "tel"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-secondary-phone",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.SecondaryPhone,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('SecondaryPhone', val)),
                    placeholder: "Ingrese teléfono secundario",
                    type: "tel"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_6,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createTextVNode(" En calidad de titular de la información y/o representante legal del(la) estudiante, autorizo de manera libre, previa, expresa e informada a la "),
                _hoisted_7,
                _createTextVNode(" responsable del proceso de preinscripción y matrícula para "),
                _hoisted_8,
                _createTextVNode(" los datos personales suministrados en este formulario, conforme a la "),
                _hoisted_9,
                _createTextVNode(" y el "),
                _hoisted_10,
                _createTextVNode(". "),
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _createTextVNode(" (i) gestionar el proceso de preinscripción y matrícula; (ii) verificación de identidad y contacto con acudientes; (iii) gestión académica y administrativa (grupos, horarios, comunicaciones institucionales, novedades); (iv) atención de solicitudes, PQRS y soporte; (v) cumplimiento de obligaciones legales, administrativas y de archivo; (vi) seguridad y control de acceso a instalaciones y/o plataformas; y (vii) reportes y estadísticas internas asociadas al servicio educativo. "),
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _createTextVNode(" se tratarán con un estándar reforzado, priorizando el interés superior del menor y el respeto de sus derechos. La autorización es otorgada por el(la) representante legal cuando aplique. "),
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                _createTextVNode(" conocer, actualizar y rectificar los datos; solicitar prueba de la autorización; ser informado(a) sobre el uso dado a la información; presentar quejas ante la autoridad competente; revocar la autorización y/o solicitar supresión cuando sea procedente; y acceder en forma gratuita a los datos. "),
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _createTextVNode(" la institución podrá apoyarse en terceros encargados del tratamiento (por ejemplo, plataformas tecnológicas) bajo instrucciones, confidencialidad y medidas de seguridad razonables, únicamente para cumplir las finalidades descritas. "),
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _createTextVNode(" los datos se conservarán por el tiempo necesario para cumplir las finalidades descritas o el exigido por normas aplicables, y podrán ser suprimidos a solicitud cuando sea procedente. "),
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _createTextVNode(" Aceptamos los costos, las fechas de pago, los planes, programas, reglamentos y acuerdos de este establecimiento educativo. Nos comprometemos a acompañar responsablemente todo el proceso del menor. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: _ctx.recordProxy.DataPolicy,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('DataPolicy', !!val))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Acepto la política de tratamiento de datos personales ")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}